export default "__VITE_ASSET__9ba8ZFWx__"